export default __webpack_public_path__ + "static/media/32_KuoChuan.4d06362a.png";